import * as React from "react";

import { Button, ButtonProps } from "@livechat/design-system-react-components";

import { StyledLink } from "components/links/StyledLink";
import { config } from "config/config";
import { isInIframe } from "helpers/app";

const IframeLink: React.FC<ButtonProps & { to: string }> = ({ to, children, ...restProps }) => {
  const isIframe = isInIframe();
  const { appUrl } = config;

  return isIframe ? (
    <Button kind="link-light" href={`${appUrl}${to}`} target="_blank" rel="nofollow noreferrer noopener" {...restProps}>
      {children}
    </Button>
  ) : (
    <StyledLink to={to} {...restProps} type="button">
      {children}
    </StyledLink>
  );
};

export default IframeLink;
